import { render } from "./DrillHoleEdgeTypeLeftRight.vue?vue&type=template&id=0a555c64"
import script from "./DrillHoleEdgeTypeLeftRight.vue?vue&type=script&lang=js"
export * from "./DrillHoleEdgeTypeLeftRight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__